import styled from '@emotion/styled';
import { colors } from '@/colors';

const { AJAIB_BLUE_1, AJAIB_BLUE_5, NEUTRAL_0, RED_1, RED_5 } = colors;

export const BadgeContainer = styled.span`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-weight: 700;

  ${({ type, orderVariant, textBuy, textSell }) => {
    switch (type) {
      case 'Multiplier':
        return null; // todo - only handle for table cell
      case 'Notation':
        return null; // todo - only handle for table cell
      case 'Prime':
        return null; // todo - only handle for table cell
      case 'Bonus':
        return `
          align-items: flex-start;
          width: 47px;
          height: 18px;
          background: ${AJAIB_BLUE_5};
          border-radius: 4px;
          font-size: 12px;
          color: ${NEUTRAL_0}
        `;
      case 'Order':
        return `
          padding: 4px 12px;
          width: ${textBuy !== 'Beli' || textSell !== 'Jual' ? '100%' : '50px'};
          height: 28px;
          background: ${orderVariant === 'SELL' ? RED_1 : AJAIB_BLUE_1};
          color: ${orderVariant === 'SELL' ? RED_5 : AJAIB_BLUE_5};
          border-radius: 16px;
          font-size: 14px;
        `;
      default:
        return null;
    }
  }}
`;
